import { useChainId, useWaitForTransactionReceipt, useWriteContract } from 'wagmi'
import { operatorRolesAbi } from '@/abi/operatorRolesAbi'
import { getContractAddress } from '@/config/contracts'

// Grant / revoke an OperatorRoles role on the currently-connected chain, signed
// by the operator's own wallet (the connected wallet must hold the role-admin,
// i.e. DEFAULT_ADMIN_ROLE / console `admin`). Modeled on unipot's
// `useAdminMutations`: a single `useWriteContract` drives both calls and
// `useWaitForTransactionReceipt` surfaces confirmation state.
export function useOperatorRoleMutations() {
    const chainId = useChainId()
    const registry = getContractAddress(chainId, 'operatorRoles')
    const { writeContract, data: hash, isPending, error, reset } = useWriteContract()
    const { isLoading: isConfirming, isSuccess } = useWaitForTransactionReceipt({ hash })

    function grant(role: `0x${string}`, account: `0x${string}`) {
        if (!registry) return
        writeContract({
            address: registry,
            abi: operatorRolesAbi,
            functionName: 'grantRole',
            args: [role, account],
        })
    }

    function revoke(role: `0x${string}`, account: `0x${string}`) {
        if (!registry) return
        writeContract({
            address: registry,
            abi: operatorRolesAbi,
            functionName: 'revokeRole',
            args: [role, account],
        })
    }

    return { grant, revoke, hash, isPending, isConfirming, isSuccess, error, reset }
}
